import React, { PureComponent } from 'react';
import { Action, bindActionCreators, Dispatch } from 'redux';
import { connect } from 'react-redux';
import UnauthedHeader from 'components/UnauthedHeader';
import { actions as accountActions } from 'reducers/Account';
import { actions as loginActions } from 'reducers/login';
import { Card } from 'Common/components/Atoms/Card';
import { Div } from 'Common/components/Atoms/Div';
import { Flex } from 'Common/components/Atoms/Flex';
import { Loading } from 'Common/components/Atoms/Loading';
import { TwoFactor } from 'Common/components/Molecules/2fa';
import { Text } from 'Common/components/Atoms/Text';
import qs from 'qs';
import { State } from '../../reducers/State';
import { LoginText } from 'DisplayText/Login';

export interface Props {
  fetchAccount: () => void;
  twoFactorChallengeToken: string | null;
  verify: (challengeToken: string, token: string) => void;
  isLoggingIn?: boolean;
  errorMessage?: string;
}

class LoginVerify extends PureComponent<Props> {
  static displayName = 'LoginVerify';

  componentDidMount() {
    const { fetchAccount } = this.props;
    /**
     * Call fetchAccount in case someone is reloading this two factor verify page. If someone is now logged in,
     * then this will automatically redirect to the logged-in state.
     */
    fetchAccount();
  }

  submit = (twoFactorToken: string) => {
    const { verify, twoFactorChallengeToken } = this.props;
    if (twoFactorChallengeToken) {
      verify(twoFactorChallengeToken, twoFactorToken);
    }
  };

  render = (): JSX.Element => {
    const { isLoggingIn, errorMessage } = this.props;
    return (
      <Div height="100vh" width="100vw" style={{ overflowY: 'auto' }}>
        <UnauthedHeader {...this.props} />
        <Text variant="h1" textAlign="center" mt={10} mb={4}>
          {LoginText.TWO_FACTOR_AUTHENTICATION}
        </Text>
        <Card display="block" width={500} m="auto" px={5} py={4} mb={6}>
          <Flex alignItems="center" flexDirection="column">
            <Text variant="h3" mb={3}>
              {LoginText.ENTER_AUTHENTICATOR_CODE}
            </Text>
            <Div display={isLoggingIn ? 'none' : undefined}>
              <TwoFactor handleSubmitCallback={this.submit} autoFocus={true} />
            </Div>
            {isLoggingIn && <Loading />}
          </Flex>
          <Flex justifyContent="center" mt={3}>
            <Text variant="body1" color="error">
              {errorMessage}
            </Text>
          </Flex>
        </Card>
      </Div>
    );
  };
}

interface OwnProps {
  location: {
    search: string;
  };
}

function mapStateToProps(state: State, ownProps: OwnProps) {
  const { login } = state;

  let twoFactorChallengeToken = login?.twoFactorChallengeToken;
  const queryToken = qs.parse(ownProps.location.search, {
    ignoreQueryPrefix: true,
  })['2fa_challenge_token'];
  if (!twoFactorChallengeToken && queryToken) {
    twoFactorChallengeToken = queryToken.toString();
  }

  return {
    isLoggingIn: login?.isLoading,
    errorMessage: login?.error,
    twoFactorChallengeToken,
  };
}

function mapDispatchToProps(dispatch: Dispatch<Action>) {
  return bindActionCreators({ ...accountActions, ...loginActions }, dispatch);
}

export default connect(mapStateToProps, mapDispatchToProps)(LoginVerify);
